import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-10 paper" data-testid="payment-cancel-page">
      <div className="brut-card p-10 max-w-md text-center bg-[#FDFCF8]">
        <div className="w-20 h-20 mx-auto brut-border bg-[#FF90E8] flex items-center justify-center"><XCircle size={48}/></div>
        <h1 className="font-display font-black text-4xl mt-5">Payment Cancelled</h1>
        <p className="text-[#4A4A4A] mt-2">No money was charged. You can retry your booking anytime.</p>
        <div className="flex gap-2 mt-6 justify-center">
          <Link to="/dashboard" className="brut-btn">Go to dashboard</Link>
          <Link to="/properties" className="brut-btn white">Browse PGs</Link>
        </div>
        {bookingId && <p className="text-xs text-[#4A4A4A] mt-4">Booking ID: {bookingId}</p>}
      </div>
    </div>
  );
}
